import React, { useState } from "react"
import styled from "styled-components"
import { theme } from "@/common/Mixin"
import Button from "@/common/components/_UI/ButtonNew"
import { Tab, Tabs } from "@mui/material"
import { ProductNames, SolutionNames } from "@/common/data/Products"
import ProductCard from "./ProductCard/ProductCard"

const Fade = require("react-reveal/Fade")

export interface TabPanelProps {
  name: string
  content: (ProductNames | SolutionNames)[]
}

export interface ProductViewMoreProps {
  title: string
  tab: TabPanelProps[]
  actionText?: string
  selectedProduct?: string
  commonT: any
}

export default function ProductViewMore({
  title,
  tab,
  actionText,
  selectedProduct
}: ProductViewMoreProps) {
  const [curTab, setTab] = useState(0)
  const renderPanel = (index: number) => {
    return tab[index].content.map((content, i) => {
      return (
        <ProductCard
          key={content}
          selected={selectedProduct === content}
          productName={ProductNames[content as keyof typeof ProductNames]}
        />
      )
    })
  }
  return (
    <Wrapper className="kg-wrapper">
      <TitleWrapper>{title}</TitleWrapper>
      <ContentWrapper>
        <MyTabs
          value={tab[curTab].name}
          onChange={(e, val) => {
            setTab(tab.findIndex(({ name }) => name === val))
          }}
        >
          {tab.map(({ name, content }, index) => (
            <MyTab
              disableRipple
              className="body-bold"
              label={name}
              key={index}
              value={name}
            ></MyTab>
          ))}
        </MyTabs>
        {tab.map((tab, index) => (
          <PanelWrapper
            key={index}
            style={{ display: curTab === index ? "grid" : "none" }}
          >
            {renderPanel(index)}
          </PanelWrapper>
        ))}
      </ContentWrapper>
      <ButtonWrapper>
        {actionText && (
          <Fade bottom>
            <Button
              styleType="text"
              className="button-header"
              content={actionText}
              href="/products"
            />
          </Fade>
        )}
      </ButtonWrapper>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  padding-top: 5vh;
  padding-bottom: 5vh;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  gap: 24px;
  align-self: stretch;
`

const MyTab = styled(Tab)`
  text-transform: none;
  padding: 0 32px;
  color: ${theme.color.textContrast} !important;
  &.Mui-selected {
    color: ${theme.color.textContrast} !important;
  }
`

const MyTabs = styled(Tabs)`
  .MuiTabs-indicator {
    background-color: ${theme.color.textContrast};
  }
`

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  width: 100%;
  gap: 32px;
`

const TitleWrapper = styled.h3`
  align-self: stretch;
  color: ${theme.color.primary};
  text-align: left;
`

const PanelWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 22%));
  grid-gap: 32px;
  width: 100%;

  @media (${theme.lg}) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (${theme.sm}) {
    grid-template-columns: repeat(1, 1fr);
  }
`

const ButtonWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: end;
`
